import type {
	Message,
	Metadata,
	StreamResponse,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export type InteractionModeRequested = 'fast' | 'auto' | 'think_deeper' | 'deep_research' | 'max';

type RequestedModeParams = {
	deepResearchEnabled?: boolean;
	thinkDeeperEnabled?: boolean;
	alphaExtendedThinkingMode?: unknown;
	taskModeEnabled?: boolean;
	fastModeEnabled?: boolean;
};

export const getInteractionModeRequested = ({
	deepResearchEnabled,
	thinkDeeperEnabled,
	alphaExtendedThinkingMode,
	taskModeEnabled,
	fastModeEnabled,
}: RequestedModeParams): InteractionModeRequested => {
	if (deepResearchEnabled) {
		return 'deep_research';
	}

	if (thinkDeeperEnabled || alphaExtendedThinkingMode) {
		return 'think_deeper';
	}

	if (taskModeEnabled) {
		return 'max';
	}

	if (fastModeEnabled) {
		return 'fast';
	}

	return 'auto';
};

export const getInteractionModeExecutedFromMetadata = (
	metadata?: Pick<Metadata, 'interaction_mode_executed'> | null,
): string | undefined => metadata?.interaction_mode_executed ?? undefined;

export const getInteractionModeExecutedFromMessage = (
	message?: Pick<Message, 'message_metadata'> | null,
): string | undefined => getInteractionModeExecutedFromMetadata(message?.message_metadata);

export const getInteractionModeExecutedFromStreamResponse = (
	streamResponse?: Pick<StreamResponse, 'message'> | null,
): string | undefined => getInteractionModeExecutedFromMessage(streamResponse?.message?.message);

export const getInteractionModeExecutedFromStoreAssistant = (
	storeAssistant?: Pick<StoreAssistant, 'content'> | null,
): string | undefined => getInteractionModeExecutedFromStreamResponse(storeAssistant?.content);

export const interactionModeRequestedAttributes = (
	interactionModeRequested?: string,
): { interactionModeRequested?: string } =>
	interactionModeRequested ? { interactionModeRequested } : {};

export const interactionModeExecutedAttributes = (
	interactionModeExecuted?: string,
): { interactionModeExecuted?: string } =>
	interactionModeExecuted ? { interactionModeExecuted } : {};
